<div class="chat-container-all" [class.open]="isOpen">
  <button class="help-button" *ngIf="!isOpen && showHelpButton() && helpButtonText">
    {{helpButtonText}}
    <span class="close-help-icon" (click)="hideHelpButton()">✖</span>
  </button>

  <div class="chat-header" (click)="toggleChat()" *ngIf="!isOpen">
    <svg xmlns="http://www.w3.org/2000/svg" 
          fill="#ffffff" viewBox="0 0 24 24" 
          width="24" height="24">
        <path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>
    </svg>
  </div>

  <div class="chat-body" *ngIf="isOpen">

    <div class="chat-container" #chatContainerSpace>
      <div class="header-container">
        <button mat-icon-button (click)="toggleChat()" class="close-icon" aria-label="Cerrar chat">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px;" class="close-mat-icon">close</mat-icon>
        </button>

        @if(talkToAdmin) {
          <button class="suport-button" *ngIf="userIdentified()" (click)="openRepresentativeDialog()">
              {{ talkToAdmin }}
              <mat-icon class="suport-icon">support_agent</mat-icon>
          </button>
        }

        <span class="current-user" *ngIf="userIdentified()" matTooltip="{{ userEmailOrPhone }}">
          {{userEmailOrPhone}}
        </span>
        <button class="btn-cerrar-app" *ngIf="isElectron()" (click)="cerrarApp()" >Cerrar app</button>

      </div>

      <div #messagesContainer class="messages">
        <web-loader id="loader_dashboard" [show]="loader"></web-loader>

        <span *ngIf="showNoUserMsg()" class="noUserMsgText">
          Usuario sin permiso para escribir.
        </span>

        <!-- <div *ngIf="!userIdentified()" class="email-container">
          <span class="noUserMsgText">
            Por favor ingresa un email / telefono.
          </span>
          <input
              class="input-email"
              [(ngModel)]="userEmailOrPhone"
              placeholder="Escribí tu email o teléfono"
              (keyup.enter)="sendQuery()"
              autofocus
            />
            <mat-icon (click)="sendQuery()" style="cursor: pointer;">send</mat-icon>
        </div> -->

        <div *ngIf="!userIdentified()" class="email-container">
        <mat-card class="email-card">
          <mat-card-content>
            <div class="email-header">
              <mat-icon color="primary">person_outline</mat-icon>
              <span class="email-title">Identificate para comenzar</span>
            </div>

            <p class="email-subtitle">
              Por favor, ingresa tu <strong>email</strong> o <strong>teléfono</strong> antes de iniciar la conversación.
            </p>

          <div class="chat-input-container">
            <input type="text" placeholder="Escribe un mensaje..." [(ngModel)]="userEmailOrPhone" />
            <button (click)="sendQuery()">
              <mat-icon>send</mat-icon>
            </button>
          </div>
          </mat-card-content>
        </mat-card>
      </div>


        <span *ngIf="humanRequest()" class="humanRequestMsg">
          Pronto serás atendido por uno de nuestros representantes.
        </span>

        <button class="assigned-button" *ngIf="currentAssigned()" >
            Chat asignado a: {{currentAssigned()}}
        </button>

        <div *ngFor="let msg of this.chatHistory()" class="message" [ngClass]="msg.role">
          <!-- <span>{{ msg.content }}</span> -->
          <div *ngIf="msg.htmlContent; else plainText" [innerHTML]="msg.htmlContent"></div>
          <ng-template #plainText>
            <span>{{ msg.content }}</span>
          </ng-template>

          <div *ngFor="let p of msg.productos" class="product-text-wrap">
            <img [src]="p.imagen" alt="Imagen del producto" class="product-img-float" />

            <h4>{{ p.nombre }}</h4>
            <p *ngIf="p.precio">💲 {{ p.precio }}</p>

            <p *ngIf="p.descripcion">
              {{ isExpanded[p.link] ? p.descripcion : truncate(p.descripcion, 150) }}
              <a *ngIf="p.descripcion.length > 150" (click)="toggleExpand(p.link)">
                {{ isExpanded[p.link] ? 'Leer menos' : 'Leer más' }}
              </a>
            </p>

            <a mat-raised-button color="primary" class="product-button" [href]="p.link" target="_blank">
              <mat-icon>open_in_new</mat-icon>
              Ver producto
            </a>
          </div>


        </div>
        <div *ngIf="isTyping()" class="typing-indicator">Escribiendo...</div>
      </div>

      @if(userIdentified()) {
      <div class="input-area">
        <input
          [disabled]="(disabledInput() && showNoUserMsg() || !userIdentified())"
          [(ngModel)]="userQuery"
          placeholder="Escribí tu pregunta..."
          (keyup.enter)="sendQuery()"
          autofocus
        />
        <mat-icon (click)="sendQuery()" style="cursor: pointer;" *ngIf="userIdentified()">send</mat-icon>
        <!-- <button (click)="sendQuery()" class="btn-send">Enviar</button> -->
      </div>
      }


    <a class="developer-info" href="https://beeasy-ai.web.app" target="_blank" rel="noopener noreferrer">
      Desarrollado por Beeasy<br>
    </a>

    <a class="developer-info" href="https://beeasy-ai.web.app/privacy" target="_blank" rel="noopener noreferrer">
      Chateando, aceptas nuestra política de privacidad.
    </a>
    </div>

  </div>
</div>

<ng-template #representativeDialog>
  <h2 mat-dialog-title>¿Querés hablar con un representante?</h2>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close="false">No</button>
    <button mat-flat-button color="primary" mat-dialog-close="true">Sí</button>
  </mat-dialog-actions>
</ng-template>